module.exports = __webpack_public_path__ + "img/scen.44ca5865.jpg";